import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { client } from '../../api/client'

const translationsAdapter = createEntityAdapter({
    selectId: x => x.key
})

const initialState = translationsAdapter.getInitialState({
    status: 'idle',
    error: null,
})

export const fetchTranslations = createAsyncThunk('translations/Get', async () => {
    const response = await client.get('/Translations')
    return response.data
})

const translationsSlice = createSlice({
    name: 'translations',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchTranslations.pending]: (state, action) => {
            state.status = 'loading'
            state = undefined
        },
        [fetchTranslations.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            translationsAdapter.addMany(state, action.payload)
        },
        [fetchTranslations.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }
    },
})

export default translationsSlice.reducer

export const {
    selectAll: selectAllTranslations,
    selectById: selectTranslationsById,
} = translationsAdapter.getSelectors((state) => state.translations)